module.exports = __webpack_public_path__ + "img/0Q3B3793_L_Wood_MockedUp.6bb7c1f2.jpg";